import { _ } from "svelte-i18n"
import { get } from "svelte/store"

export function clickIsOutsideDateModal(e: MouseEvent, el?: HTMLElement): boolean {
    const dateModal = el ? el : document.getElementById("dateModal")
    const clickOutsideDateModal = !dateModal || !dateModal.contains(e.target as Node)
    console.log("clickOutsideDateModal", clickOutsideDateModal, dateModal)
    const clickNotOnDateModalCell = !(e.target as Element).classList.contains("datepicker-cell")
    if (clickOutsideDateModal && e.target !== document && clickNotOnDateModalCell) {
        return true
    }
    return false
}
export const datepickerLanguage = {
    days: get(_)("components.datepicker.days"),
    daysShort: get(_)("components.datepicker.daysShort"),
    daysMin: get(_)("components.datepicker.daysMin"),
    months: get(_)("components.datepicker.months"),
    monthsShort: get(_)("components.datepicker.monthsShort"),
    today: get(_)("components.datepicker.today"),
    clear: get(_)("components.datepicker.clear"),
    titleFormat: get(_)("components.datepicker.titleFormat"),
    format: get(_)("components.datepicker.format"),
    weekStart: 1,
}
